<template>
  <div class="i-footer">
    <div class="links">
      <a
        class="link"
        href="https://www.jobtest.org/terms-of-service"
        target="_blank"
        >Terms of Use</a
      >
      <a
        class="link"
        href="https://www.jobtest.org/privacy-policy"
        target="_blank"
        >Privacy Policy</a
      >
    </div>
    <img
      class="logo"
      :src="logoWhite"
      loading="lazy"
      alt="Jobtest Logo"
    />
    <div class="company-name">Realign, Inc. (Jobtest.org)</div>
  </div>
</template>

<script lang="ts" setup>
// ASSETS
import logoWhite from "@/assets/logo/logo-white.svg"
</script>

<style scoped lang="scss">
.i-footer {
  width: 100%;
  padding: 24px;
  background-color: $black;

  @include flex($direction: column, $justify: center, $align: center);

  row-gap: 12px;

  @media screen and (min-width: $breakpoint-lg) {
    padding: 48px;
  }

  @media screen and (min-width: $breakpoint-md) {
    flex-direction: row;
    row-gap: unset;
    justify-content: space-around;
  }

  .links {
    @include flex($direction: row, $justify: center, $align: center);

    column-gap: 24px;

    .link {
      color: $brand-opacity100;
      text-decoration: none;
    }
  }

  .company-name {
    @include text-sm;

    color: $black300;
  }
}
</style>
